import { useTrackEvent } from '@/App/Blotter/useTrackEvent.ts';
import { useAlgoTileId, useValidateAlgo } from '@/App/tiles/orders/AlgoOrders/AlgoContext.tsx';
import { OrderRow } from '@/App/tiles/orders/components/OrderRow.tsx';
import { OmsFieldErrorWrapper } from '@/components/ui/OmsFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectAlgoErrors, selectAlgoSpreadCapture } from '@/store/orders/algoOrders/selectors.ts';

export const AlgoSpreadCapture = () => {
  const tileId = useAlgoTileId();
  const track = useTrackEvent();

  const value = useAppSelector((state) => selectAlgoSpreadCapture(state, tileId));
  const errors = useAppSelector((state) => selectAlgoErrors(state, tileId));

  const validateAlgo = useValidateAlgo();

  const handleSpreadCaptureChange = (newValue: boolean) => {
    track('Order action', 'Spread capture changed');
    validateAlgo({
      spreadCapture: newValue,
    });
  };

  const spreadCaptureError = errors?.spreadCapture;

  return (
    <OrderRow labelId="order.fields.spreadCapture">
      <OmsFieldErrorWrapper errors={spreadCaptureError}>
        <div className="form-check form-check-sm">
          <input
            id="spreadCapture"
            className="form-check-input me-8px"
            type="checkbox"
            checked={value}
            onChange={(e) => handleSpreadCaptureChange(e.target.checked)}
            data-e2e={'spread-capture-checkbox'}
          />
        </div>
      </OmsFieldErrorWrapper>
    </OrderRow>
  );
};
